import React from 'react';

import { ReactComponent as LikeIcon } from '@assets/icons/costing/like.svg';
import { ReactComponent as DislikeIcon } from '@assets/icons/costing/unlike.svg';
import { ReactComponent as LikedIcon } from '@assets/icons/costing/liked.svg';
import { ReactComponent as UnlikedIcon } from '@assets/icons/costing/unliked.svg';

import CustomTooltip from '@/components/CustomTooltip';
import CommonImage from '@/components/CommonImage';

const CostingSummary = ({ summary = {}, totalFobPerUnit, isLiked, onLike, onDislike, isLoading = false }) => {
	return (
		<div className="costing-summary border p-3">
			<div className="d-flex justify-content-between">
				<div>
					<p className="semibold-14 gray_dark_01">Costing Summary</p>
				</div>

				<div className="text-right">
					<p className="regular-12 gray_dark_01">FOB Per Unit</p>
					<div className="d-flex align-items-center align-items-center justify-content-end gap-1">
						<p className="price-title weight-500 gray_dark_01 pt-1">
							${(totalFobPerUnit || 0).toFixed(2)}
						</p>
						<CustomTooltip placement="top" arrowCenter={true} text={'8.70% wastage added'}>
							<span className="cursor-pointer">
								<CommonImage
									src="/icons/info.svg"
									alt="info"
									width={18}
									height={18}
									className="cursor-pointer"
								/>
							</span>
						</CustomTooltip>
					</div>
				</div>
			</div>
			<div className="summary-content mt-4">
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Fabric Consumption</p>
					<p className="regular-14 gray_dark_01">{summary.fabricConsumption || 0} kg</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Fabric Cost</p>
					<p className="regular-14 gray_dark_01">${(summary.fabricCost || 0).toFixed(2)}</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Print Cost</p>
					<p className="regular-14 gray_dark_01">${(summary.printCost || 0).toFixed(2)}</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Embroidery Cost</p>
					<p className="regular-14 gray_dark_01">${(summary.embroideryCost || 0).toFixed(2)}</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Trims Cost</p>
					<p className="regular-14 gray_dark_01">${(summary.trimsCost || 0).toFixed(2)}</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">CM Cost</p>
					<p className="regular-14 gray_dark_01">${(summary.cmCost || 0).toFixed(2)}</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Wash Cost</p>
					<p className="regular-14 gray_dark_01">${(summary.washCost || 0).toFixed(2)}</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Packaging</p>
					<p className="regular-14 gray_dark_01">${(summary.packaging || 0).toFixed(2)}</p>
				</div>
				<div className="d-flex justify-content-between pb-2">
					<p className="regular-14 weight-500 gray_dark_02">Commercial</p>
					<p className="regular-14 gray_dark_01">${(summary.commercial || 0).toFixed(2)}</p>
				</div>
			</div>
			<div className="content-bottom border-top pt-3 d-flex justify-content-between">
				<p className="regular-12 gray_dark_02">Did you like this cost?</p>
				<div className="d-flex align-items-center gap-2">
					{isLiked === null || isLiked === undefined ? (
						<>
							<LikeIcon
								width={14}
								height={14}
								className="cursor-pointer"
								onClick={() => !isLoading && onLike && onLike()}
								style={{
									opacity: isLoading ? 0.5 : 1,
									pointerEvents: isLoading ? 'none' : 'auto'
								}}
							/>
							<DislikeIcon
								width={14}
								height={14}
								className="cursor-pointer"
								onClick={() => !isLoading && onDislike && onDislike()}
								style={{
									opacity: isLoading ? 0.5 : 1,
									pointerEvents: isLoading ? 'none' : 'auto'
								}}
							/>
						</>
					) : isLiked === true ? (
						<LikedIcon width={14} height={14} style={{ opacity: 1, cursor: 'default' }} />
					) : (
						<UnlikedIcon width={14} height={14} style={{ opacity: 1, cursor: 'default' }} />
					)}
				</div>
			</div>
		</div>
	);
};

export default CostingSummary;
